module.exports = __webpack_public_path__ + "media/images/icons/twotone/smile-d5ffa9f92963be2177bfcca11e32acfd.svg";